// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"224":"19efaf5b9aa3b043","423":"7617e4c52dda0be3"}[chunkId] + ".js";
};